import React from 'react'
import PropTypes from 'prop-types'
import Skeleton from '../UI/Skeleton'

class TermsContent extends React.Component {
    constructor(props) {
        super(props)
        this.sortTerm = this.sortTerm.bind(this)
    }

    filter(e, id) {
        const terms = document.querySelectorAll('.terms-post')
        const chars = document.querySelectorAll('.terms-char-title')
        terms.forEach((term) => term.classList.add('d-none'))
        chars.forEach((char) => char.classList.remove('bg-primary'))
        document.getElementById(`term-${id}`).classList.remove('d-none')
        e.target.classList.add('bg-primary')
    }

    unfilter() {
        const terms = document.querySelectorAll('.terms-post')
        const chars = document.querySelectorAll('.terms-char-title')
        terms.forEach((term) => term.classList.remove('d-none'))
        chars.forEach((char) => char.classList.remove('bg-primary'))
    }

    sortTerm(e, id) {
        if (e.target.classList.contains('bg-primary')) {
            this.unfilter()
        } else {
            this.filter(e, id)
        }
    }

    render() {
        return (
            <React.Fragment>
                {
                    this.props.skeleton ?
                        <Skeleton image={true} className="my-10px ml-0 mr-20px" height={37} width={37} />
                        :
                        <div
                            className="news-desc terms-char-title md-font-size"
                            onClick={(e) => this.sortTerm(e, this.props.id)}
                        >
                            {this.props.char}
                        </div>
                }
            </React.Fragment>

        )
    }
}

TermsContent.propTypes = {
    char: PropTypes.string,
    id: PropTypes.number,
    skeleton: PropTypes.bool,
}

export default TermsContent



// WEBPACK FOOTER //
// ./src/components/Terms/TermsChars.jsx